import * as colors from "../theme/colors";

export const REACT_APP_CALENDAR_EVENT_MAX_CONFIGURABLE_ATTENDEES_DEFAULT = 1000;

export const ADDED_BY_PARENT = 'ADDED_BY_PARENT';
export const ADDED_BY_CHILD = 'ADDED_BY_CHILD';

export const PROGRAM_TYPES = {
  CLUB: "CLUB",
  COLLEGE_LOOP: 'COLLEGE_LOOP',
  SIP: "SIP",
  COMMUNITY_PARTNERSHIP: "COMMUNITY_PARTNERSHIP",
  SPP: "SPP",
}

export const PROGRAM_ROLE_IDS = {
  Facilitator: 1,
  Member: 2,
  Viewer: 3,
}

export const TASK_STATUSES = {
  review: null,
  incomplete: 0,
  complete: 1,
  notStarted: -1,
};

export const SCHOOL_CLUBS = {
  ELEMENTARY_SCHOOL: 'Elementary School',
  HIGH_SCHOOL: 'High School',
  K12_SCHOOL: 'K-12 School',
  MIDDLE_SCHOOL: 'Middle School',
  MS_HS: 'MS/HS',
  PRIVATE_SCHOOL: 'Private School',
  PUBLIC_SCHOOL: 'Public School'
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_TIMEZONE = 'YYYY-MM-DDT00:00:00Z';

export const cpProgramTypeDetails = {
  programType: PROGRAM_TYPES.COMMUNITY_PARTNERSHIP,
  name: 'Community Partnership',
  backgroundColor: colors.darkThemeGreen,
  fontColor: colors.white,
  programIcon: 'communityPartnershipIcon',
};

export const projectOptionTypes = {
  playground: "playground",
  project: "project",
  program: "program",
  tag: "tag",
  studentName: "student name",
  all: "all",
};

export const projectTypes = {
  IDE: 'ide',
  ProjectGallery: 'gallery',
}

export const projectTypeLabels = {
  [projectOptionTypes.all]: "All Projects",
  [projectOptionTypes.playground]: "Playground",
  [projectTypes.IDE]: "BlockJam",
  [projectTypes.ProjectGallery]: "Project Gallery",
};

export const PROJECT_TYPES = {
  web: "web",
  python: "python",
  scratch: "scratch",
};

export const EXTENSIONS = {
  p5: "p5",
}

export const ParamToProjectType = {
  "py": PROJECT_TYPES.python,
  "web": PROJECT_TYPES.web,
  "p5": PROJECT_TYPES.web,
}

export const IDE_TEMPLATES = {
  web: "web",
  python: "py",
  p5js: "p5",
};

export const TAG_LABELS = {
  blockJam: "BlockJam",
  textJam: "TextJam",
  web: "Web",
  python: "Python",
  p5: "p5.js",
  playground: "Playground",
}

export const ProjectTypeToParam = {
  [PROJECT_TYPES.python]: "py",
  [PROJECT_TYPES.web]: "web",
  [EXTENSIONS.p5]: "p5",
}

export const IDE_TYPES = {
  BLOCK_JAM: "blockjam",
  TEXT_JAM: "textjam",
};
